import React, { useState } from 'react';
import api from '../../api';
import apifunctions from '../../api/functions.js';
import axios from 'axios';
import { FormFeedback } from 'reactstrap';
import ParadigmaModal from '../../components/ParadigmaModal/ParadigmaModal';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import InputMask from 'react-input-mask';

const ProductividadExportModal = (props) => {
    const { ejecutor } = props;
    const [downloading, setDownloading] = useState(false);
    const [fechaDesde, setFechaDesde] = useState(moment());
    const [fechaHasta, setFechaHasta] = useState(moment());
    const parseDate = (date) => moment(date && date._d ? date._d : date);

    const downloadXLS = () => {
        const failureCallback = () => setDownloading(false);
        const successCallback = (response) => {
            setDownloading(false);
            let today = new Date();
            let dd = String(today.getDate()).padStart(2, '0');
            let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            let yyyy = today.getFullYear();
            let fileName = `Productividad - ${dd}-${mm}-${yyyy}.xlsx`;

            let downloadLink = window.document.createElement('a');

            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(response.data, fileName);
            } else {
                downloadLink.href = window.URL.createObjectURL(new Blob([response.data]));
                downloadLink.download = fileName;
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }
        };
        const headers = apifunctions.headers();
        headers.responseType = 'blob';
        const data = {
            ejecutor_id: ejecutor,
            filters: {
                fechaDesde: fechaDesde.format("YYYY-MM-DD"),
                fechaHasta: fechaHasta.format("YYYY-MM-DD"),
            }
        }
        setDownloading(true);
        // apifunctions.post(api.proyectos.cargadatos.productividad.export, null, data, successCallback, failureCallback, failureCallback);
        axios.post(
            api.proyectos.cargadatos.productividad.export,
            data,
            headers
        ).then(successCallback).catch(failureCallback);
    }
    return (
        <ParadigmaModal
            title={"Seleccionar período productividades"}
            buttonTitle={"Descargar productividades"}
            buttonIcon={"fa fa-download"}
            saveButton={true}
            closeButton={true}
            onSubmit={downloadXLS}
            className={"ui-modal-dialog ui-modal-md"}
        >
            <div className="ui-form">
                <section className="ui-section-block">
                    {downloading && (
                        <div className="ui-alert ui-alert-info">
                            Preparando descarga de productividades.
                        </div>
                    )}
                    <div className="ui-row-2">
                        <div className="ui-field">
                            <label>Fecha Desde</label>
                            <DatePicker
                                selected={fechaDesde}
                                onChange={(e) => setFechaDesde(parseDate(e))}
                                disabled={false}
                                timeFormat=""
                                className="form-control"
                                name={"fechaDesde"}
                                timeIntervals={15}
                                dateFormat="DD/MM/YYYY"
                                timeCaption="time"
                                customInput={<InputMask name="fechaDesde" className="form-control" mask="99/99/9999" type="text" />}
                            />
                            <FormFeedback className="col-12"></FormFeedback>
                        </div>
                        <div className="ui-field">
                            <label>Fecha Hasta</label>
                            <DatePicker
                                selected={fechaHasta}
                                onChange={(e) => setFechaHasta(parseDate(e))}
                                disabled={false}
                                timeFormat=""
                                className="form-control"
                                name={"fechaHasta"}
                                timeIntervals={15}
                                dateFormat="DD/MM/YYYY"
                                timeCaption="time"
                                customInput={<InputMask name="fechaHasta" className="form-control" mask="99/99/9999" type="text" />}
                            />
                            <FormFeedback className="col-12"></FormFeedback>
                        </div>
                    </div>
                </section>
            </div>
        </ParadigmaModal>
    );
}
export default ProductividadExportModal;



// WEBPACK FOOTER //
// ./src/views/Consultas/ProductividadExportModal.js